<template>
  <div id="games" class="menu-container animated slideInLeft">
    <!-- Gaming Section -->
    <div class="squareGame animated slideInLeft"
         :class="{ 'hover-active': hover.gaming }"
         @click="toggleMenu('gaming', $event)"
         @mouseenter="handleHover('gaming', true)"
         @mouseleave="handleHover('gaming', false)">
      <div class="imgGame gaming"></div>
      <transition name="fade">
        <span class="gameTitle" v-if="hover.gaming || hover.showOtherTitles">Gaming</span>
      </transition>
      <div class="submenu animated slideInRightFromFar"
           v-if="hover.gaming"
           @mouseenter="handleSubmenuHover('gaming', true)">
        <router-link to="/speed-running">
          <div id="SpeedRunning" class="storeGame"><span class="submenu-text">General Speedrunning</span></div>
        </router-link>
        <router-link to="/marble-blast-ultra">
          <div id="Marble" class="storeGame"><span class="submenu-text">Marble Blast Ultra</span></div>
        </router-link>
        <router-link to="/other-games">
          <div id="OtherGames" class="storeGame unfinished"><span class="submenu-text">Other Games</span></div>
        </router-link>
        <router-link to="/controller-modding">
          <div id="ControllerModding" class="storeGame unfinished"><span class="submenu-text">Controller Modding</span></div>
        </router-link>
      </div>
    </div>


    <!-- Game Development Section -->
    <div class="squareGame animated slideInLeft"
                  :class="{ 'hover-active': hover.gamedev }"
         @click="toggleMenu('gamedev', $event)"
         @mouseenter="handleHover('gamedev', true)"
         @mouseleave="handleHover('gamedev', false)">
      <div class="imgGame gamedev"></div>
      <transition name="fade">
        <span class="gameTitle" v-if="hover.gamedev || hover.showOtherTitles">Game Development</span>

      </transition>

      <div class="submenu animated slideInRightFromFar"
           v-if="hover.gamedev"
           @mouseenter="hover.gamedev = true">
        <a href="/fortnite-island-analytics.html" target="_blank">
          <div id="FortniteAnalytics" class="storeGame"><span class="submenu-text">FN Island Analytics</span></div>
        </a>
        <a href="/fortnite-sprite-trader.html" target="_blank">
          <div id="FortniteSpriteTrader" class="storeGame"><span class="submenu-text">FN Sprite Trader</span></div>
        </a>
        <router-link to="/hobohat-games">
          <div id="HobohatGames" class="storeGame"><span class="submenu-text">Hobohat Games</span></div>
        </router-link>
        <router-link to="/iclone">
          <div id="Iclone" class="storeGame unfinished"><span class="submenu-text">Iclone</span></div>
        </router-link>
        <router-link to="/ninja-legend">
          <div id="NinjaLegend" class="storeGame unfinished"><span class="submenu-text">Ninja Legend</span></div>
        </router-link>
        <router-link to="/phase-shift">
          <div id="PhaseShift" class="storeGame unfinished"><span class="submenu-text">Phase Shift</span></div>
        </router-link>
        <router-link to="/lets-be-friends">
          <div id="LetsBeFriends" class="storeGame unfinished"><span class="submenu-text">Let's Be Friends</span></div>
        </router-link>
      </div>
    </div>

    <!-- PC Build Section -->
    <div class="squareGame animated slideInLeft"
                  :class="{ 'hover-active': hover.software }"
         @click="toggleMenu('software', $event)"
         @mouseenter="handleHover('software', true)"
         @mouseleave="handleHover('software', false)">

      <div class="imgGame software"></div>
      <transition name="fade">

        <span class="gameTitle" v-if="hover.software || hover.showOtherTitles">Projects</span>
      </transition>
      <div class="submenu animated slideInRightFromFar"
           v-if="hover.software"
           @mouseenter="hover.software = true">
        <router-link to="/pc-build">
          <div id="PCBuild" class="storeGame"><span class="submenu-text">PC Build</span></div>
        </router-link>
        <router-link to="/automatic-plex-torrenting">
          <div id="Plex" class="storeGame"><span class="submenu-text">Automatic Plex</span></div>
        </router-link>
        <router-link to="/auto-update-cloudflare-dns">
          <div id="AutoUpdate" class="storeGame"><span class="submenu-text">Auto Update Cloudflare DNS</span></div>
        </router-link>
        <a href="https://marble.pittroche.co.uk/about">
          <div id="Blazor" class="storeGame"><span class="submenu-text">Marble Leaderboards</span></div>
        </a>
      </div>

    </div>
    <!-- Programming & Modding Section -->
    <div class="squareGame animated slideInLeft "
                  :class="{ 'hover-active': hover.programming }"
         @click="toggleMenu('programming', $event)"
         @mouseenter="handleHover('programming', true)"
         @mouseleave="handleHover('programming', false)">
      <div class="imgGame programming"></div>
      <transition name="fade">

        <span class="gameTitle" v-if="hover.programming || hover.showOtherTitles">Programming</span>

      </transition>

      <div class="submenu animated slideInRightFromFar"
           v-if="hover.programming"
           @mouseenter="hover.programming = true">
        <router-link to="/getting-into-programming">
          <div id="GettingIntoProgramming" class="storeGame unfinished"><span class="submenu-text">How I got into Programming</span></div>
        </router-link>
        <router-link to="/personal-projects">
          <div id="PersonalProjects" class="storeGame unfinished"><span class="submenu-text">Personal Projects</span></div>
        </router-link>
        <router-link to="/cloudflare">
          <div id="Cloudflare" class="storeGame"><span class="submenu-text">Cloudflare</span></div>
        </router-link>
        <router-link to="/visual-studio-beginner-tricks">
          <div id="VSTips" class="storeGame"><span class="submenu-text">Visual Studio Beginner Tricks</span></div>
        </router-link>
      </div>
    </div>



    <div class="squareGame animated slideInLeft nosubmenu unfinished">
      <router-link to="/about-me" aria-label="About Me">
        <div class="imgGame about "></div>
        <transition name="fade">

          <span class="gameTitle" v-if="hover.about || hover.showOtherTitles">About Me</span>
        </transition>

      </router-link>
    </div>

    <!-- Tools Section (Locked Until Login) -->
    <div class="squareGame animated slideInLeft"
                  :class="{ 'hover-active': hover.tools }"
         @click="toggleMenu('tools', $event)"
         @mouseenter="handleHover('tools', true)"
         @mouseleave="handleHover('tools', false)">
      <div class="imgGame tools" :class="{ locked: !user || user.roles != 'Admin' }"></div>
      <transition name="fade">

        <span class="gameTitle" v-if="hover.tools || hover.showOtherTitles">Tools</span>
      </transition>


      <div class="submenu animated slideInRightFromFar"
           v-if="hover.tools"
           @mouseenter="hover.tools = true">
        <a v-for="tool in tools" :key="tool.id" :href="tool.url" target="_blank">
          <div :id="tool.id" class="storeGame"><span class="submenu-text">{{ tool.name }}</span></div>
        </a>
      </div>
    </div>
  </div>


</template>

<script>
  import { useAuthStore, fetchWithOrWithoutAuth, fetchWithAuth, refreshToken, startTokenRefreshTimer } from 'shared-vue'

  import { mapState } from 'pinia';
  export default {
    data() {
      return {
        hover: {
          gaming: false,
          programming: false,
          gamedev: false,
          about: false,
          tools: false,
          software:false,
          alwaysShowTitle: true, // Show all titles by default
          showOtherTitles: true // Toggle based on hover state
        },
        isAuthenticated: false,
        showPasswordPrompt: false,
        password: "",
        tools: [] // Holds dynamically fetched tool links
      };
    },
    computed: {
      ...mapState(useAuthStore, ['user']),
      isAdmin() {
        return this.user?.roles?.includes("Admin");
      }
    },
    watch: {
      user(newUser, oldUser) {
        if (newUser && !oldUser && this.isAdmin) {
          /*console.log("Admin logged in, fetching tools...");*/
          this.fetchTools();
        }
      }
    },
    methods: {
      handleHover(section, isEntering) {
        this.hover.showOtherTitles = isEntering ? false : this.hover.alwaysShowTitle;
        this.hover[section] = isEntering;
      },
      handleSubmenuHover(section, isEntering) {
        // Keep the parent hovered when submenu is hovered
        if (!this.isTouchDevice) {
          this.hover[section] = isEntering;
        }
      },
      toggleMenu(section) {
        // Only use click to toggle for touch devices
        if (this.isTouchDevice) {
          this.hover[section] = !this.hover[section];
        }
      },
      async fetchTools() {
        if (!this.isAdmin) {
          /*console.log("User is not an admin, skipping fetchTools()");*/
          return;
        }

        try {         

          const response = await fetchWithAuth("/tools");

          const data = await response.json();
          if (data.tools) {
            this.tools = data.tools;
          } else {
            alert("Unauthorized. Please log in again.");
            localStorage.removeItem("authToken");
          }
        } catch (error) {
          console.error("Error fetching tools:", error);
        }
      }
    },
    created() {
       this.fetchTools();
    }
  };

</script>

<style scoped>
  *, *::before, *::after {
    box-sizing: content-box;
  }

  .tools {
    background-image: url("/assets/me.png");
  }



  .software {
    background-image: url("/assets/Software.png");
  }

  .gaming {
    background-image: url("/assets/xbox.png");
  }

  .programming {
    background-image: url("/assets/programming.png");
  }

  .gamedev {
    background-color: #333;
    background-image: url("/assets/robloxgamesIcon.png");
  }
  .about {
    background-image: url("/assets/AboutMe.png");
  }

  #Sonarr {
    background-image: url("/assets/tvicon.png");
  }

  #Radarr {
    background-image: url("/assets/movieicon.png");
  }

  #HobohatGames {
    background-image: url("/assets/HobohatGames.jpeg");
  }

  #Iclone {
    background-color: #333;
    background-image: url("/assets/IClone.png");
  }

  #PhaseShift {
    background-color: #333;
    background-image: url("/assets/PhaseShift.png");
  }

  #NinjaLegend {
    background-image: url("/assets/Legend.png");
  }

  #Trello {
    background-color: #ffffff;
    background-image: url("/assets/Trello.png");
  }

  #LetsBeFriends {
    background-image: url("/assets/LetsBeFriends.png");
  }

  #Marble {
    background-image: url("/assets/marble.png");
  }

  #GettingIntoProgramming {
    background-image: url("/assets/meprogramming.png");
  }

  #PersonalProjects {
    background-image: url("/assets/personalprojects.png");
  }

  #SpeedRunning {
    background-image: url("/assets/speedrunning.png");
  }

  #OtherGames {
    background-image: url("/assets/othergames.png");
  }

  #Plex {
    background-image: url("/assets/Plex.png");
  }
  #Repo {
    background-color: #ffffff;
    background-image: url("/assets/GitHub.png");
  }

  #Software {
    background-image: url("/assets/Software.png");
  }
  #PCBuild {
    background-image: url("/assets/pcbuild.png");
  }
  #PersonalProjectsSecure {
    background-image: url("/assets/pps.png");
  }
  #Cloudflare {
    background-color: #ffffff;
    background-image: url("/assets/Cloudflare.png");
  }
  #ControllerModding {
    background-image: url("/assets/ControllerModding.png");
  }
  #VSTips {
    background-image: url("/assets/VSTips.png");
  }
  #Blazor {
    background-image: url("/assets/Leaderboard.png");
  }
  #AutoUpdate {
    background-image: url("/assets/AutoUpdateDNS.png");
  }
  #FortniteAnalytics {
    background-image: url("/assets/fortnite-analytics.svg");
    background-color: #0a0e1a;
  }
  #FortniteSpriteTrader {
    background-image: url("/assets/fortnite-sprite-trader.svg");
    background-color: #0a0e1a;
  }
  #TestPaymentPage {
    background-color: #ff00ff;
  }

</style>
